<template>
    <Toast/>
    <div class="simple-layout-wrapper flex align-items-center justify-content-center h-auto min-h-screen">
        <div class="main">
            <router-view />
        </div>
    </div>
</template>

<script>
    import Toast from "primevue/toast";

    export default {
        name: "LayoutSimple",
        components: {Toast},

    };
</script>

<style lang="scss">
    @import "../assets/scss/layout-simple";
</style>
